module.exports = {
    "contact_center_type": "inContact",
    "settingsApi": {
        "baseUrl": "https://northwestern.patient-assist.staging.agenta-cloud.com/",
        "url": "adpac/v3/getsettings",
        "fetchOnLogin": true,
        "_fetchOnLogin_comment": "Creds stay in ts-config until Settings API can supply them securely (ts-config is visible in browser). Load settings at startup — do not defer until login."
    },
    "authApi": {
        "enabled": true,
        "url": "adpac/v1/getauthtoken",
        "method": "POST",
        "tokenType": "Bearer"
    },
    "_ehrSource_comment": "ehr block: always used for Settings API ?ehr= query param. ehrSource \"settings\" (default): app runtime EHR from Settings API / settings.json. ehrSource \"tsconfig\": also force runtime EHR from this file — set one ehr flag true and the rest false.",
    "ehrSource": "settings",
    "ehr": {
        "epic": true,
        "cerner": false,
        "athena": false,
        "meditech": false,
        "nextgen": false,
        "ecw": false
    },
    "queryparameter": true,
    "simulator": false,
    "makeacall": {
        "_comment1": "This is to configure prefix (Code to Dial out from extension) to make a call feature which is present in source and subject cards",
        "prefix": "91"
    },
    "inContact_callvariables": {
        "_comments": "inContact callvariables which are added in VCC will generate a Biginterger value which needs to be configured in config file",
        "organizationId": "131960",
        "variables": {
            "caller_sourceid": {
                "name": "sourceid",
                "group": "Caller"
            },
            "patient_subjectid": {
                "name": "subjectid",
                "group": "Patient"
            }
        }
    },
    "send_epic_client_id": false
}
;